import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-public-home',
  standalone: true,
  imports: [RouterLink],
  template: `
    <main class="sb-landing">
      <section class="sb-hero">
        <div class="sb-hero-watermark sb-hero-watermark-main" aria-hidden="true"></div>
        <div class="sb-hero-watermark sb-hero-watermark-side" aria-hidden="true"></div>
        <div class="sb-hero-watermark sb-hero-watermark-soft" aria-hidden="true"></div>
        <div class="sb-shell">
          <a href="https://www.jaguarcrm360.com/" class="sb-suite-link">&larr; Suite</a>

          <div class="sb-hero-grid">
            <div>
              <h1 class="sb-title">StudioBooth</h1>
              <p class="sb-lead">Convertí cualquier evento en una experiencia fotográfica digital interactiva.</p>
              <a routerLink="/admin" class="sb-access-button">Acceso</a>
            </div>

            <div class="sb-hero-media">
              <img src="/landing-portadastudiobooth.jpg" alt="StudioBooth" loading="eager" decoding="async" fetchpriority="high" />
            </div>
          </div>
        </div>
      </section>

      <section class="sb-shell sb-content">
        <div class="sb-main-grid">
          <div class="sb-main-column">
            <section class="sb-purpose">
              <h2>El <span>Propósito</span></h2>
              <p>
                Conectá con tus invitados a través de una experiencia digital moderna, simple y memorable. Hacé que cada
                persona capture sus mejores momentos desde su celular, los personalice con el marco de tu evento, los firme
                y deje mensajes dedicados, deseos, felicitaciones o recuerdos especiales.
              </p>
            </section>

            <section>
              <div class="sb-section-head">
                <h3>Sus <span>Características</span></h3>
                <p>Principales ventajas y funcionalidades diseñadas para elevar la experiencia al máximo nivel.</p>
              </div>

              <div class="sb-features">
                @for (feature of features; track feature.number) {
                  <article class="sb-feature">
                    <span>{{ feature.number }}</span>
                    <p>{{ feature.text }}</p>
                  </article>
                }
              </div>
            </section>

            <section>
              <div class="sb-centered-head">
                <h3>El flujo de <span>la experiencia</span></h3>
                <p>Tus invitados no solo se toman fotos: participan, expresan emociones y crean contenido auténtico que puede compartirse en redes sociales, logrando que se hable de tu evento antes, durante y después.</p>
              </div>

              <div class="sb-flow">
                @for (step of steps; track step.number) {
                  <article>
                    <div>{{ step.number }}</div>
                    <h4>{{ step.title }}</h4>
                    <p>{{ step.text }}</p>
                  </article>
                }
              </div>
            </section>

            <section>
              <div class="sb-centered-head">
                <h3>Experiencia <span>Completa</span></h3>
                <p>Reuní todas esas fotos, firmas y mensajes en un mural gigante en vivo, ideal para marcas, matrimonios, graduaciones, lanzamientos y activaciones comerciales que buscan generar emoción, interacción y una experiencia que realmente deje huella.</p>
              </div>

              <article class="sb-showcase sb-wide-showcase">
                <div>
                  <h4>Mural en Vivo</h4>
                  <p>Todas las fotos en pantalla gigante al instante. Impacto visual asegurado para tu evento.</p>
                </div>
                <img class="sb-showcase-fallback" src="/landing-vista-mural.jpg" alt="Vista mural" loading="lazy" decoding="async" />
                <iframe
                  class="sb-showcase-embed"
                  src="https://evento.jaguarcrm360.com/e/activaciondemo/gallery?presentation=1"
                  title="Mural en vivo StudioBooth"
                  loading="lazy"
                  referrerpolicy="same-origin"
                  aria-label="Mural en vivo StudioBooth">
                </iframe>
              </article>

              <div class="sb-device-grid">
                <article class="sb-device-card">
                  <h4>Captura en Celular</h4>
                  <p>Los invitados se toman fotos desde su propio celular sin instalar apps. Capturan los mejores momentos, los firman y los comparten.</p>
                  <div class="sb-phone-frame">
                    <img class="sb-phone-capture" src="/landing-vista-captura-foto.jpg" alt="Vista captura foto" loading="lazy" decoding="async" />
                    <div class="sb-phone-access-panel" aria-label="Pantalla QR para participar desde el celular">
                      <iframe
                        src="https://evento.jaguarcrm360.com/e/activaciondemo/selfie-access?presentation=1&publicUrl=https:%2F%2Fevento.jaguarcrm360.com"
                        title="QR de acceso StudioBooth"
                        loading="lazy"
                        referrerpolicy="same-origin"
                        scrolling="no">
                      </iframe>
                      <div class="sb-scan-callout">
                        <span>Escaneá</span>
                        <i></i>
                      </div>
                    </div>
                  </div>
                </article>

                <article class="sb-device-card">
                  <h4>Kiosko Fotográfico</h4>
                  <p>Si dispones de un tótem LED o tablets podés usar la plataforma en formato cabina, la app se adapta. (equipo no incluido en ningún plan).</p>
                  <div class="sb-kiosk-frame">
                    <img src="/landing-vista-kiosko.jpg" alt="Vista kiosko" loading="lazy" decoding="async" />
                  </div>
                </article>
              </div>
            </section>

            <section class="sb-extra-stack">
              <article class="sb-browser-card">
                <div>
                  <h4>Panel de Moderación</h4>
                  <p>Mantén el control absoluto. Aprueba o rechaza el contenido en vivo antes de que salga en el mural.</p>
                </div>

                <div class="sb-browser-frame">
                  <div class="sb-browser-top">
                    <span></span>
                    <span></span>
                    <span></span>
                    <div></div>
                  </div>
                  <img src="/landing-vista-moderador.jpg" alt="Vista moderador" loading="lazy" decoding="async" />
                </div>
              </article>

              <article class="sb-results-card">
                <div class="sb-results-head">
                  <h4>Resultados <span>Espectaculares</span></h4>
                  <p>Las fotos finales lucen increíbles con tu diseño personalizado, branding y filtros aplicados en tiempo real.</p>
                </div>

                <div class="sb-results-grid">
                  <img src="/fotoresultado1.jpg" alt="Foto resultado 1" loading="lazy" decoding="async" />
                  <img src="/fotoresultado2.jpg" alt="Foto resultado 2" loading="lazy" decoding="async" />
                  <img src="/fotoresultado3.jpg" alt="Foto resultado 3" loading="lazy" decoding="async" />
                </div>
                <p class="sb-image-note">* Fotos de personas generadas por IA con fines demostrativos.</p>
              </article>
            </section>

            <section class="sb-no-booth">
              <h3>Cada celular se convierte en parte de la experiencia</h3>
              <p>
                Cada celular puede convertirse en una mini cabina fotográfica. La versatilidad de la plataforma permite
                hacer activaciones incluso sin tótems.
              </p>
              <div class="sb-check-grid">
                <span>Celulares de los invitados para participación masiva.</span>
                <span>Una tablet o laptop como punto fijo de captura.</span>
                <span>Una pantalla externa si quieres mostrar el mural en vivo.</span>
                <span>Un QR impreso para que todos entren fácilmente.</span>
              </div>
            </section>

            <section>
              <div class="sb-section-head">
                <h3>Ideas de <span>Activaciones</span></h3>
                <p>Descubre cómo StudioBooth transforma diferentes tipos de eventos en experiencias memorables.</p>
              </div>

              <div class="sb-activation-grid">
                <article class="sb-activation-card">
                  <div class="sb-activation-images sb-two-images">
                    <img src="/landing-activacionmatrimonio.jpg" alt="Activación matrimonio" loading="lazy" decoding="async" />
                    <img src="/landing-activacionmatrimonio2.jpg" alt="Activación matrimonio 2" loading="lazy" decoding="async" />
                  </div>
                  <div class="sb-activation-body">
                    <h4>Matrimonios</h4>
                    <p>Los invitados pueden tomarse fotos espontáneas, dejar mensajes para los novios y descargar su recuerdo al instante.</p>
                    <span>"Comparte tu mejor recuerdo con los novios."</span>
                  </div>
                </article>

                <article class="sb-activation-card">
                  <div class="sb-activation-images sb-brand-images">
                    <img src="/landing-activacionferias.jpg" alt="Activación de marca" loading="lazy" decoding="async" />
                    <img src="/landing-activaciondemarca2.jpg" alt="Activación de marca 2" loading="lazy" decoding="async" />
                    <img src="/landing-activaciondemarca3.jpg" alt="Activación de marca 3" loading="lazy" decoding="async" />
                  </div>
                  <div class="sb-activation-body">
                    <h4>Activaciones de Marca</h4>
                    <p>Perfecto para stands, lanzamientos y campañas comerciales con recolección de datos para futuras campañas.</p>
                    <span>"Tómate una foto, aparece en el mural y participa."</span>
                  </div>
                </article>

                <article class="sb-activation-card sb-wide-activation">
                  <div class="sb-activation-cover">
                    <img src="/landing-activaciongraduacion.jpg" alt="Activación graduación" loading="lazy" decoding="async" />
                  </div>
                  <div class="sb-activation-body">
                    <h4>Graduaciones y Fiestas</h4>
                    <p>Captura cada momento de celebración con marcos alusivos y mensajes del colegio, universidad o anfitrión.</p>
                    <span>"Captura el éxito y el inicio de una nueva etapa."</span>
                  </div>
                </article>

                <article class="sb-activation-card sb-wide-activation sb-reverse-activation">
                  <div class="sb-activation-cover">
                    <img src="/landing-activacion2.jpg" alt="Eventos corporativos" loading="lazy" decoding="async" />
                  </div>
                  <div class="sb-activation-body">
                    <h4>Eventos Corporativos</h4>
                    <p>Ideal para aniversarios, capacitaciones o fiestas de fin de año, reforzando identidad e interacción del equipo.</p>
                    <span>"Haz que tu equipo sea el protagonista."</span>
                  </div>
                </article>
              </div>
            </section>
          </div>

          <aside class="sb-sidebar">
            <div class="sb-plans">
              <h3><span>Planes</span></h3>
              <p>Elegí la opción adecuada.</p>

              @for (plan of plans; track plan.name) {
                <article class="sb-plan">
                  <div class="sb-plan-head">
                    <strong>{{ plan.name }}</strong>
                    <span>{{ plan.price }}</span>
                  </div>
                  <ul>
                    @for (item of plan.items; track item) {
                      <li>{{ item }}</li>
                    }
                  </ul>
                  <a [href]="plan.whatsappUrl" target="_blank" rel="noopener">¡Lo quiero ahora!</a>
                </article>
              }

              <div class="sb-note">
                <h4>¡Importante!</h4>
                <p>La organización del evento deberá proporcionar el fondo selfie, fondo mural, marco selfie y kiosko.</p>
                <p>La aplicación funciona con internet, por lo que el servicio de internet corre por cuenta de la organización, a excepción del Plan Premium 360, que ya incluye internet para los equipos de la activación.</p>
              </div>
            </div>
          </aside>
        </div>
      </section>

      <footer class="sb-footer">
        <div class="sb-shell sb-footer-grid">
          <div class="sb-footer-brand">
            <h3>JaguarCRM360</h3>
            <p>Somos una suite con tecnología 360°. Aplicaciones hechas a tu medida. Conectá, automatizá y vendé más creando experiencias únicas.</p>
            <a href="https://www.jaguarcrm360.com/" target="_blank" rel="noopener" class="sb-footer-cta">Visitar sitio web</a>
          </div>

          <div>
            <h3>Contacto</h3>
            <p>Email: <a href="mailto:gonzalo.jurado@jaguarcrm360.com">gonzalo.jurado&#64;jaguarcrm360.com</a></p>
            <p>Teléfono: <a href="https://wa.me/59178592101" target="_blank" rel="noopener">+591 78592101</a></p>
          </div>

          <div>
            <h3>Plataformas</h3>
            <ul>
              <li>StudioBooth</li>
              <li>LiveqrSales</li>
              <li>LobbyApp</li>
              <li>JaguarCRM360</li>
              <li>NexoMK</li>
              <li>Atención Multiagente</li>
              <li>NexoMk API oficial</li>
            </ul>
          </div>

          <p class="sb-footer-copy">Copyright © 2026 JaguarCRM360. Todos los derechos reservados.</p>
        </div>
      </footer>
    </main>
  `,
  styles: [`
    :host {
      display: block;
      min-height: 100vh;
      background: #0a0e1a;
    }

    .sb-landing {
      min-height: 100vh;
      background: #0a0e1a;
      color: #f5f5f5;
      font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    }

    .sb-shell {
      width: min(100% - 2rem, 80rem);
      margin: 0 auto;
    }

    .sb-hero {
      position: relative;
      overflow: hidden;
      background: #0f172a;
      padding: clamp(3rem, 8vw, 4.5rem) 0;
    }

    .sb-hero::after {
      content: "";
      position: absolute;
      inset: 0;
      background:
        radial-gradient(circle at 73% 36%, rgba(233, 69, 96, .055), transparent 34rem),
        linear-gradient(90deg, #0f172a 0%, rgba(15, 23, 42, .93) 38%, rgba(15, 23, 42, .74) 100%);
      pointer-events: none;
    }

    .sb-hero .sb-shell {
      position: relative;
      z-index: 2;
    }

    .sb-hero-watermark {
      position: absolute;
      top: 0;
      bottom: 0;
      background-size: cover;
      background-position: center;
      filter: grayscale(.2) saturate(.75) contrast(1.05);
      mix-blend-mode: screen;
      pointer-events: none;
    }

    .sb-hero-watermark-main {
      left: 74%;
      right: -2%;
      background-image: url('/landing-portadastudiobooth.jpg');
      opacity: .24;
    }

    .sb-hero-watermark-side {
      left: 30%;
      width: 24%;
      background-image: url('/landing-activacionmatrimonio.jpg');
      background-position: center;
      opacity: .16;
    }

    .sb-hero-watermark-soft {
      left: 52%;
      width: 24%;
      background-image: url('/landing-activaciongraduacion.jpg');
      background-position: center;
      opacity: .15;
    }

    .sb-hero-watermark-side::after,
    .sb-hero-watermark-soft::after,
    .sb-hero-watermark-main::after {
      content: "";
      position: absolute;
      inset: 0;
      background:
        linear-gradient(90deg, rgba(15, 23, 42, .55), rgba(15, 23, 42, .18)),
        linear-gradient(0deg, rgba(15, 23, 42, .38), transparent 45%, rgba(15, 23, 42, .25));
    }

    .sb-suite-link {
      display: inline-flex;
      margin-bottom: 2rem;
      color: #8892b0;
      font-family: Outfit, Inter, sans-serif;
      font-size: .75rem;
      font-weight: 700;
      letter-spacing: .18em;
      text-transform: uppercase;
      text-decoration: none;
      transition: color .2s ease;
    }

    .sb-suite-link:hover {
      color: #fff;
    }

    .sb-hero-grid {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(17rem, .42fr);
      gap: 2.5rem;
      align-items: center;
    }

    .sb-title {
      margin: 0;
      color: #fff;
      font-family: Outfit, Inter, sans-serif;
      font-size: clamp(2.8rem, 7vw, 5.8rem);
      font-weight: 900;
      letter-spacing: -.04em;
      line-height: .9;
    }

    .sb-lead {
      max-width: 48rem;
      margin: 1.25rem 0 2rem;
      color: #8892b0;
      font-size: clamp(1.15rem, 2vw, 1.35rem);
      font-weight: 300;
      line-height: 1.65;
    }

    .sb-access-button,
    .sb-plan a {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 3.25rem;
      padding: 0 1.5rem;
      border-radius: .5rem;
      background: #e94560;
      color: #fff;
      font-family: Outfit, Inter, sans-serif;
      font-size: .75rem;
      font-weight: 900;
      letter-spacing: .16em;
      text-transform: uppercase;
      text-decoration: none;
      transition: transform .2s ease, background .2s ease;
    }

    .sb-access-button:hover,
    .sb-plan a:hover {
      transform: translateY(-1px);
      background: #ff5570;
    }

    .sb-hero-media img {
      width: 100%;
      height: 12rem;
      border-radius: .75rem;
      object-fit: cover;
      opacity: .92;
      box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, .45);
    }

    .sb-content {
      padding: clamp(3.5rem, 8vw, 5rem) 0;
    }

    .sb-main-grid {
      display: grid;
      grid-template-columns: minmax(0, 2fr) minmax(18rem, 1fr);
      gap: clamp(2rem, 5vw, 4rem);
      align-items: start;
    }

    .sb-main-column {
      display: grid;
      gap: clamp(3.5rem, 8vw, 5rem);
    }

    .sb-purpose {
      padding: clamp(2rem, 5vw, 3rem);
      background: rgba(22, 33, 62, .1);
    }

    .sb-purpose h2,
    .sb-section-head h3,
    .sb-centered-head h3,
    .sb-plans h3 {
      margin: 0;
      color: #fff;
      font-family: Outfit, Inter, sans-serif;
      font-size: clamp(2rem, 4vw, 3rem);
      font-weight: 900;
      letter-spacing: -.03em;
      line-height: 1;
    }

    .sb-purpose h2 span,
    .sb-section-head h3 span,
    .sb-centered-head h3 span,
    .sb-plans h3 span {
      color: #e94560;
      font-family: Caveat, cursive;
      font-size: 1.22em;
      font-weight: 400;
      font-style: italic;
    }

    .sb-purpose p {
      margin: 1.5rem 0 0;
      color: #f5f5f5;
      font-size: 1.08rem;
      font-weight: 300;
      line-height: 2;
    }

    .sb-section-head {
      display: flex;
      align-items: end;
      justify-content: space-between;
      gap: 1.5rem;
      margin-bottom: 2.5rem;
    }

    .sb-section-head p {
      max-width: 23rem;
      margin: 0;
      padding-left: 1rem;
      border-left: 1px solid rgba(233, 69, 96, .35);
      color: #8892b0;
      font-size: .9rem;
      font-weight: 300;
      line-height: 1.7;
    }

    .sb-features {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 2rem;
    }

    .sb-feature {
      position: relative;
      display: flex;
      gap: 1rem;
      padding-top: 1rem;
      color: #f5f5f5;
    }

    .sb-feature::before {
      content: "";
      position: absolute;
      inset: 0 auto auto 0;
      width: 2rem;
      height: 1px;
      background: #16213e;
      transition: width .45s ease, background .45s ease;
    }

    .sb-feature:hover::before {
      width: 100%;
      background: #e94560;
    }

    .sb-feature span {
      color: rgba(136, 146, 176, .25);
      font-family: Outfit, Inter, sans-serif;
      font-size: 1.2rem;
      font-weight: 900;
    }

    .sb-feature p {
      margin: 0;
      font-size: 1.06rem;
      font-weight: 300;
      line-height: 1.65;
    }

    .sb-centered-head {
      max-width: 45rem;
      margin: 0 auto 3rem;
      text-align: center;
    }

    .sb-centered-head p,
    .sb-device-card p,
    .sb-showcase p,
    .sb-plans > p,
    .sb-note p {
      color: #8892b0;
      font-weight: 300;
      line-height: 1.75;
    }

    .sb-flow {
      position: relative;
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 2rem;
    }

    .sb-flow::before {
      content: "";
      position: absolute;
      top: 2.5rem;
      left: 10%;
      right: 10%;
      height: 1px;
      background: linear-gradient(90deg, transparent, #16213e, transparent);
    }

    .sb-flow article {
      position: relative;
      z-index: 1;
      display: grid;
      justify-items: center;
      text-align: center;
    }

    .sb-flow article div {
      display: grid;
      place-items: center;
      width: 5rem;
      height: 5rem;
      margin-bottom: 1.5rem;
      border: 2px solid rgba(22, 33, 62, .7);
      border-radius: 999px;
      background: #0f172a;
      color: #8892b0;
      font-family: Outfit, Inter, sans-serif;
      font-size: 1.9rem;
      font-weight: 900;
    }

    .sb-flow article:hover div {
      border-color: rgba(233, 69, 96, .5);
      color: #e94560;
    }

    .sb-flow h4,
    .sb-device-card h4,
    .sb-showcase h4 {
      margin: 0 0 .7rem;
      color: #fff;
      font-family: Outfit, Inter, sans-serif;
      font-size: 1.35rem;
      font-weight: 900;
      letter-spacing: -.02em;
    }

    .sb-flow p {
      max-width: 13rem;
      margin: 0;
      color: #8892b0;
      font-size: .9rem;
      font-weight: 300;
      line-height: 1.65;
    }

    .sb-showcase {
      position: relative;
      min-height: 30rem;
      margin-bottom: 3rem;
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, .06);
      border-radius: 1.5rem;
      background: rgba(22, 33, 62, .06);
      box-shadow: 0 2rem 5rem rgba(0, 0, 0, .25);
    }

    .sb-showcase::after {
      content: "";
      position: absolute;
      inset: 0;
      z-index: 2;
      background: linear-gradient(0deg, rgba(0, 0, 0, .82), transparent 55%);
      pointer-events: none;
    }

    .sb-showcase img,
    .sb-showcase iframe {
      width: 100%;
      height: 100%;
      min-height: 30rem;
    }

    .sb-showcase img {
      object-fit: cover;
      transition: transform 1s ease;
    }

    .sb-showcase:hover img {
      transform: scale(1.045);
    }

    .sb-showcase-embed {
      position: absolute;
      inset: 0;
      z-index: 1;
      border: 0;
      background: #0f172a;
      width: 100%;
      height: 100%;
      min-height: 30rem;
    }

    .sb-showcase-fallback {
      position: absolute;
      inset: 0;
      z-index: 0;
    }

    .sb-showcase div {
      position: absolute;
      left: clamp(1.5rem, 4vw, 2.5rem);
      right: clamp(1.5rem, 4vw, 2.5rem);
      bottom: 1.5rem;
      z-index: 3;
      pointer-events: none;
    }

    .sb-showcase h4 {
      font-size: clamp(1.8rem, 3vw, 2.4rem);
    }

    .sb-device-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 2rem;
    }

    .sb-device-card {
      display: grid;
      justify-items: center;
      overflow: hidden;
      padding: 2rem;
      border: 1px solid rgba(22, 33, 62, .7);
      border-radius: 1.25rem;
      background: rgba(22, 33, 62, .07);
      text-align: center;
    }

    .sb-phone-frame {
      position: relative;
      width: min(16.25rem, 100%);
      height: 32.5rem;
      margin-top: 1.75rem;
      overflow: hidden;
      border: .5rem solid #27272a;
      border-radius: 2.5rem;
      background: #000;
      box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, .45);
    }

    .sb-phone-frame::before {
      content: "";
      position: absolute;
      top: .25rem;
      left: 50%;
      z-index: 1;
      width: 4rem;
      height: .5rem;
      border-radius: 999px;
      background: #000;
      transform: translateX(-50%);
    }

    .sb-kiosk-frame {
      width: min(17.5rem, 100%);
      aspect-ratio: 9 / 16;
      margin-top: 1.75rem;
      overflow: hidden;
      border: .28rem solid #3f3f46;
      border-radius: 1.5rem;
      background: #000;
      padding: .75rem;
      box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, .4);
    }

    .sb-phone-frame img,
    .sb-kiosk-frame img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .sb-phone-capture {
      position: absolute;
      inset: 0;
      animation: phoneCaptureCycle 16s ease-in-out infinite;
    }

    .sb-phone-access-panel {
      position: absolute;
      inset: 0;
      overflow: hidden;
      background: #0f172a;
      opacity: 0;
      animation: phoneAccessCycle 16s ease-in-out infinite;
    }

    .sb-phone-access-panel iframe {
      position: absolute;
      left: 0;
      top: 0;
      width: 150%;
      height: 150%;
      border: 0;
      background: #0f172a;
      pointer-events: none;
      transform: scale(.6667);
      transform-origin: left top;
    }

    .sb-scan-callout {
      position: absolute;
      top: 2.4rem;
      left: 50%;
      z-index: 3;
      display: inline-flex;
      align-items: center;
      gap: .55rem;
      padding: .55rem .8rem;
      border: 1px solid rgba(255, 255, 255, .16);
      border-radius: 999px;
      background: rgba(7, 10, 18, .72);
      color: #fff;
      backdrop-filter: blur(16px);
      font-family: Outfit, Inter, sans-serif;
      font-size: .68rem;
      font-weight: 900;
      letter-spacing: .12em;
      text-transform: uppercase;
      transform: translateX(-50%);
      box-shadow: 0 .9rem 2rem rgba(0, 0, 0, .28), 0 0 0 1px rgba(233, 69, 96, .28);
      animation: scanCalloutFloat 1.6s ease-in-out infinite;
    }

    .sb-scan-callout i {
      width: .7rem;
      height: .7rem;
      border-right: 2px solid currentColor;
      border-bottom: 2px solid currentColor;
      transform: rotate(45deg);
    }

    @keyframes phoneCaptureCycle {
      0%, 34% { opacity: 1; transform: scale(1); }
      42%, 92% { opacity: 0; transform: scale(1.03); }
      100% { opacity: 1; transform: scale(1); }
    }

    @keyframes phoneAccessCycle {
      0%, 36% { opacity: 0; transform: scale(1.02); }
      44%, 88% { opacity: 1; transform: scale(1); }
      96%, 100% { opacity: 0; transform: scale(1.02); }
    }

    @keyframes scanCalloutFloat {
      0%, 100% { transform: translate(-50%, 0); }
      50% { transform: translate(-50%, .35rem); }
    }

    .sb-kiosk-frame img {
      border-radius: .75rem;
    }

    .sb-sidebar {
      position: sticky;
      top: 2rem;
    }

    .sb-plans {
      padding: 2rem;
      border: 1px solid rgba(22, 33, 62, .7);
      border-radius: 1rem;
      background: rgba(22, 33, 62, .07);
    }

    .sb-plan {
      display: flex;
      flex-direction: column;
      gap: 1.25rem;
      margin-top: 1rem;
      padding: 1.25rem;
      border: 1px solid transparent;
      border-radius: .9rem;
      background: rgba(22, 33, 62, .22);
      transition: border .25s ease, background .25s ease;
    }

    .sb-plan:hover {
      border-color: rgba(233, 69, 96, .35);
      background: rgba(22, 33, 62, .38);
    }

    .sb-plan-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: .8rem;
      color: #fff;
      font-family: Outfit, Inter, sans-serif;
    }

    .sb-plan-head span {
      flex: 0 0 auto;
      padding: .35rem .55rem;
      border-radius: .35rem;
      background: #16213e;
      font-size: .8rem;
    }

    .sb-plan ul {
      display: grid;
      gap: .75rem;
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .sb-plan li {
      color: #8892b0;
      font-size: .9rem;
      font-weight: 300;
      line-height: 1.5;
    }

    .sb-plan li::before {
      content: "•";
      color: #e94560;
      margin-right: .5rem;
    }

    .sb-plan a {
      width: 100%;
      min-height: 2.75rem;
      background: rgba(233, 69, 96, .18);
      color: #e94560;
    }

    .sb-note {
      margin-top: 1rem;
      padding: 1.25rem;
      border-left: 2px solid #e94560;
      border-radius: 0 .75rem .75rem 0;
      background: rgba(22, 33, 62, .12);
    }

    .sb-note h4 {
      margin: 0 0 .6rem;
      color: #fff;
      font-family: Outfit, Inter, sans-serif;
      font-weight: 700;
    }

    .sb-note p + p {
      margin-top: .85rem;
    }

    .sb-extra-stack {
      display: grid;
      gap: 2rem;
    }

    .sb-browser-card,
    .sb-results-card,
    .sb-no-booth,
    .sb-activation-card {
      overflow: hidden;
      border: 1px solid rgba(22, 33, 62, .7);
      border-radius: 1.25rem;
      background: rgba(22, 33, 62, .07);
    }

    .sb-browser-card,
    .sb-no-booth {
      padding: clamp(1.5rem, 4vw, 2rem);
    }

    .sb-browser-card h4,
    .sb-results-card h4,
    .sb-no-booth h3,
    .sb-activation-body h4 {
      margin: 0 0 .65rem;
      color: #fff;
      font-family: Outfit, Inter, sans-serif;
      font-size: clamp(1.55rem, 3vw, 2rem);
      font-weight: 900;
      letter-spacing: -.025em;
    }

    .sb-browser-card p,
    .sb-results-card p,
    .sb-no-booth p,
    .sb-activation-body p {
      margin: 0;
      color: #8892b0;
      font-weight: 300;
      line-height: 1.75;
    }

    .sb-browser-frame {
      margin-top: 2rem;
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, .08);
      border-radius: 1rem;
      background: #09090b;
      box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, .35);
    }

    .sb-browser-top {
      display: flex;
      align-items: center;
      gap: .5rem;
      padding: .8rem 1rem;
      border-bottom: 1px solid rgba(255, 255, 255, .08);
      background: #111827;
    }

    .sb-browser-top span {
      width: .7rem;
      height: .7rem;
      border-radius: 999px;
    }

    .sb-browser-top span:nth-child(1) { background: rgba(239, 68, 68, .75); }
    .sb-browser-top span:nth-child(2) { background: rgba(245, 158, 11, .75); }
    .sb-browser-top span:nth-child(3) { background: rgba(34, 197, 94, .75); }

    .sb-browser-top div {
      flex: 1;
      height: 1.45rem;
      margin-left: .75rem;
      border-radius: .4rem;
      background: rgba(255, 255, 255, .06);
    }

    .sb-browser-frame img {
      display: block;
      width: 100%;
      aspect-ratio: 16 / 9;
      object-fit: cover;
      object-position: left top;
      opacity: .92;
    }

    .sb-results-card {
      position: relative;
      padding: clamp(1.5rem, 4vw, 2rem);
      background: rgba(22, 33, 62, .06);
    }

    .sb-results-head h4 {
      font-size: clamp(2rem, 4vw, 3rem);
      line-height: 1;
    }

    .sb-results-head h4 span {
      color: #e94560;
      font-family: Caveat, cursive;
      font-size: 1.22em;
      font-weight: 400;
      font-style: italic;
    }

    .sb-results-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 1rem;
      margin-top: 2rem;
      align-items: start;
    }

    .sb-results-grid img {
      width: 100%;
      border: 1px solid rgba(255, 255, 255, .1);
      border-radius: 1rem;
      background: rgba(0, 0, 0, .25);
      box-shadow: 0 1.3rem 3rem rgba(0, 0, 0, .35);
      transition: transform .45s ease;
    }

    .sb-results-grid img:nth-child(2) {
      margin-top: 2rem;
    }

    .sb-results-grid img:nth-child(3) {
      margin-top: .75rem;
    }

    .sb-results-grid img:hover {
      transform: translateY(-.45rem);
    }

    .sb-image-note {
      margin-top: 1rem !important;
      color: rgba(136, 146, 176, .65) !important;
      font-size: .75rem;
      text-align: right;
    }

    .sb-no-booth {
      background: rgba(22, 33, 62, .08);
    }

    .sb-no-booth > p {
      margin-top: 1.15rem;
      color: #f5f5f5;
      font-size: 1.05rem;
    }

    .sb-check-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 1rem;
      margin-top: 1.75rem;
    }

    .sb-check-grid span {
      position: relative;
      padding-left: 1.6rem;
      color: #8892b0;
      font-weight: 300;
      line-height: 1.6;
    }

    .sb-check-grid span::before {
      content: "✓";
      position: absolute;
      left: 0;
      top: 0;
      color: #e94560;
      font-weight: 900;
    }

    .sb-activation-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 1.5rem;
    }

    .sb-activation-card {
      display: flex;
      flex-direction: column;
      background: rgba(22, 33, 62, .07);
      transition: transform .25s ease;
    }

    .sb-activation-card:hover {
      transform: translateY(-.2rem);
    }

    .sb-activation-images {
      display: grid;
      gap: .25rem;
      padding: .5rem;
      background: rgba(0, 0, 0, .32);
    }

    .sb-two-images {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .sb-brand-images {
      grid-template-columns: 2fr 1fr;
      grid-template-rows: repeat(2, minmax(0, 1fr));
    }

    .sb-brand-images img:first-child {
      grid-row: span 2;
    }

    .sb-activation-images img,
    .sb-activation-cover img {
      width: 100%;
      height: 100%;
      min-height: 12rem;
      border-radius: .8rem;
      object-fit: cover;
      transition: transform .7s ease;
    }

    .sb-activation-card:hover img {
      transform: scale(1.04);
    }

    .sb-activation-body {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      padding: clamp(1.5rem, 4vw, 2rem);
    }

    .sb-activation-body span {
      display: inline-flex;
      align-self: flex-start;
      margin-top: 1.5rem;
      padding: .85rem 1rem;
      border: 1px solid rgba(255, 255, 255, .06);
      border-radius: .75rem;
      background: rgba(15, 23, 42, .45);
      color: #e94560;
      font-family: Outfit, Inter, sans-serif;
      font-size: .74rem;
      font-weight: 900;
      letter-spacing: .12em;
      line-height: 1.5;
      text-transform: uppercase;
    }

    .sb-wide-activation {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: 2fr 3fr;
      min-height: 20rem;
    }

    .sb-wide-activation .sb-activation-cover {
      min-height: 100%;
      padding: .5rem;
      background: rgba(0, 0, 0, .32);
    }

    .sb-wide-activation .sb-activation-cover img {
      min-height: 100%;
    }

    .sb-reverse-activation .sb-activation-cover {
      order: 2;
    }

    .sb-footer {
      border-top: 1px solid rgba(255, 255, 255, .06);
      background: #070a12;
      padding: clamp(2.5rem, 6vw, 4rem) 0;
    }

    .sb-footer-grid {
      display: grid;
      grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr) minmax(0, .9fr);
      gap: 2rem;
      align-items: start;
    }

    .sb-footer h3 {
      margin: 0 0 1rem;
      color: #fff;
      font-family: Outfit, Inter, sans-serif;
      font-size: .8rem;
      font-weight: 900;
      letter-spacing: .18em;
      text-transform: uppercase;
    }

    .sb-footer p,
    .sb-footer li,
    .sb-footer a {
      color: #8892b0;
      font-size: .95rem;
      font-weight: 300;
      line-height: 1.8;
      text-decoration: none;
    }

    .sb-footer a:hover {
      color: #e94560;
    }

    .sb-footer-brand p {
      max-width: 32rem;
    }

    .sb-footer-cta {
      display: inline-flex;
      margin-top: 1rem;
      color: #e94560 !important;
      font-family: Outfit, Inter, sans-serif;
      font-size: .75rem !important;
      font-weight: 900 !important;
      letter-spacing: .14em;
      text-transform: uppercase;
    }

    .sb-footer-cta:hover {
      color: #ff5570 !important;
    }

    .sb-footer ul {
      display: grid;
      gap: .45rem;
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .sb-footer-copy {
      grid-column: 1 / -1;
      margin: 1rem 0 0 !important;
      padding-top: 1.5rem;
      border-top: 1px solid rgba(255, 255, 255, .06);
      color: rgba(136, 146, 176, .72) !important;
      font-size: .85rem !important;
    }

    @media (max-width: 960px) {
      .sb-hero-grid,
      .sb-main-grid,
      .sb-device-grid,
      .sb-activation-grid,
      .sb-wide-activation {
        grid-template-columns: 1fr;
      }

      .sb-sidebar {
        position: static;
      }

      .sb-wide-activation {
        display: flex;
      }

      .sb-reverse-activation .sb-activation-cover {
        order: 0;
      }
    }

    @media (max-width: 760px) {
      .sb-section-head {
        align-items: start;
        flex-direction: column;
      }

      .sb-features,
      .sb-flow,
      .sb-results-grid,
      .sb-check-grid {
        grid-template-columns: 1fr;
      }

      .sb-flow::before {
        display: none;
      }

      .sb-showcase,
      .sb-showcase img {
        min-height: 24rem;
      }

      .sb-results-grid img:nth-child(2),
      .sb-results-grid img:nth-child(3) {
        margin-top: 0;
      }

      .sb-footer-grid {
        grid-template-columns: 1fr;
      }
    }
  `]
})
export class PublicHome implements OnInit, OnDestroy {
  private readonly chatScriptId = 'studiobooth-landing-chatwoot';

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  ngOnInit() {
    this.loadLandingChat();
  }

  ngOnDestroy() {
    if (!isPlatformBrowser(this.platformId)) return;
    document.getElementById(this.chatScriptId)?.remove();
    document.querySelectorAll(
      '.woot-widget-holder, .woot-widget-bubble, .woot--bubble-holder, #chatwoot_live_chat_widget'
    ).forEach((node) => node.remove());
  }

  features = [
    { number: '01', text: 'Fotos desde el celular' },
    { number: '02', text: 'Mural en vivo con moderación' },
    { number: '03', text: 'Marcos visuales personalizados' },
    { number: '04', text: 'Descarga directa e instantánea' },
    { number: '05', text: 'Captura de leads: nombre y WhatsApp' },
    { number: '06', text: 'Fondos y logos personalizados con tu marca' },
  ];

  steps = [
    { number: '1', title: 'Diseño y Setup', text: 'Personaliza la app con logo, marco y fondos de pantalla.' },
    { number: '2', title: 'Escaneo QR', text: 'Los invitados ingresan escaneando desde su propio teléfono.' },
    { number: '3', title: 'Captura', text: 'Se toman una foto al instante usando nuestra interfaz web.' },
    { number: '4', title: 'Mural en Vivo', text: 'La foto viaja directo a la pantalla grande y también está lista en el teléfono para descargar y compartir.' },
  ];

  plans = [
    {
      name: 'PLAN FLASH',
      price: '1.500 Bs',
      whatsappUrl: this.whatsappPlanUrl('PLAN FLASH'),
      items: [
        '1 activación/evento/día',
        'Acceso a App StudioBooth',
        'Personalización de las pantallas',
        'Fotos ilimitadas',
        'Descarga de fotos para la organización e invitados',
        'Captura de números de teléfono',
        'Moderación de contenido',
        'Soporte y configuración',
      ],
    },
    {
      name: 'PLAN EXPERIENCIA 360',
      price: '3.500 Bs',
      whatsappUrl: this.whatsappPlanUrl('PLAN EXPERIENCIA 360'),
      items: [
        '1 activación o evento max 6Hr.',
        'Acceso a App StudioBooth',
        'Personalización de las pantallas',
        'Fotos ilimitadas',
        'Descarga de fotos para la organización e invitados',
        'Captura de números de teléfono',
        'Moderación de contenido',
        'Alquiler de pantalla LED P3.9, medidas 4 x 2 m',
        'Soporte y configuración',
      ],
    },
    {
      name: 'PLAN PREMIUM 360',
      price: '7.800 Bs',
      whatsappUrl: this.whatsappPlanUrl('PLAN PREMIUM 360'),
      items: [
        '1 activación o evento max 6Hr',
        'Acceso a App StudioBooth',
        'Personalización de las pantallas',
        'Fotos ilimitadas',
        'Descarga de fotos para la organización e invitados',
        'Captura de números de teléfono',
        'Moderación de contenido',
        'Alquiler de pantalla LED P3.9, medidas 6 x 2,5 m',
        'Personal impulsador: 2 personas',
        'Luces decorativas para el mural',
        'Internet para los equipos de la activación',
        'Soporte y configuración',
      ],
    },
  ];

  private whatsappPlanUrl(planName: string) {
    const text = `Hola, quiero información sobre StudioBooth y el ${planName}.`;
    return `https://wa.me/59178592101?text=${encodeURIComponent(text)}`;
  }

  private loadLandingChat() {
    if (!isPlatformBrowser(this.platformId) || document.getElementById(this.chatScriptId)) return;

    const baseUrl = 'https://chat.jaguarcrm360.com';
    const script = document.createElement('script');
    script.id = this.chatScriptId;
    script.src = `${baseUrl}/packs/js/sdk.js`;
    script.async = true;
    script.onload = () => {
      const chatwootSDK = (window as any).chatwootSDK;
      if (!chatwootSDK?.run) return;
      chatwootSDK.run({
        websiteToken: '4NR3Eq5EPPPFEyuBqKNBEkPn',
        baseUrl,
      });
    };
    document.body.appendChild(script);
  }
}
